import { Navigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn');

  if (!isLoggedIn) {
    return <Navigate to="/signin" replace />;
  }

  return (
    <div className="flex flex-col min-h-screen bg-[#032210]">
      <Header />
      <main className="flex-grow p-4">
        {children}
      </main>
      {/* <Footer /> */}
    </div>
  );
};

export default ProtectedRoute;
